/**
 * @voltxampere/ui — DS18B20 OneWire digital temperature sensor variant (Sprint 43-6, placeholder)
 *
 * PLACEHOLDER. Digital OneWire temperature sensor returning a
 * 12-bit signed reading in 0.0625 °C steps. Real OneWire bus
 * simulation lands Sprint 47+ along with MCU-side OneWire master
 * support. The placeholder ships as an idealized voltage source.
 *
 * Reference: Maxim DS18B20. OneWire 1-Wire protocol, parasite-power
 * capable, range -55 to +125 °C, Vcc 3-5.5 V.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorDs18b20 = {
    id: "ds18b20",
    nameTr: "DS18B20 (OneWire Dijital Sıcaklık Sensörü, placeholder)",
    nameEn: "DS18B20 (OneWire Digital Temperature Sensor, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "DS18B20",
    schemaType: "voltage-source",
    defaultParams: { voltage: 3.3 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-ds18b20.js.map